import { Component } from '@angular/core';

@Component({
  selector: 'app-page-subheader',
  templateUrl: './page-subheader.component.html',
  styleUrl: './page-subheader.component.scss',
  standalone: true,
})
export class PageSubheaderComponent {}
